import { useTranslation } from 'react-i18next';

import type { TOTPEnrollment } from '@rootsight/shared';
import { Link, Stack } from '@rootsight/ui';

import { OTPQRCode } from './OTPQRCode';

/**
 * TOTPSetup shows a new authenticator app's secret three ways: a QR code to
 * scan, a link a phone opens straight in its app, and the key to type.
 */
export function TOTPSetup({ enrollment }: { enrollment: TOTPEnrollment }) {
  const { t } = useTranslation('auth');
  return (
    <Stack gap={3}>
      <p>{t('login.enroll.scan')}</p>
      <OTPQRCode uri={enrollment.uri} alt={t('login.enroll.qrAlt')} />
      <Link href={enrollment.uri}>{t('login.enroll.openApp')}</Link>
      <p>
        {t('login.enroll.keyIntro')}{' '}
        <code className="rs-mono" dir="ltr">
          {enrollment.secret}
        </code>
      </p>
    </Stack>
  );
}
